import script from "./BaseAccordion.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseAccordion.vue?vue&type=script&lang=ts&setup=true"

import "./BaseAccordion.vue?vue&type=style&index=0&id=1f22b9bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f22b9bc"]])

export default __exports__